var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-root"},[_c('side-bar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('nav-bar'),_c('div',{attrs:{"id":"sansanll-content"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }